export const brand = {
  name: "BB's Micros",
  tagline: "Evidenced by Science, Powered by Plants",
  siteOrigin: "https://bbs.bionicbloom.org",
  assets: {
    logoMark: "/brand/logo-mark.png",
    ogImage: "/brand/og.png",
  },
  phone: {
    e164: "+17274909911",
    display: "(727) 490-9911",
    smsBody: "Hi!",
  },
  location: {
    label: "407 1st Ave N, St. Petersburg, FL 33701",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=407+1st+Ave+N%2C+St.+Petersburg%2C+FL+33701",
  },
  privacyPolicyUrl: "https://bloomintegratedhealth.com/privacy",
  aboutUrl: "https://bloomintegratedhealth.com/",
} as const;
